<template>
  <BaseSection :step="step">

    <template #title>Confirm Changes</template>

    <template #content>
      <v-form>

        <div class="mb-4">
          Please make sure all information on the right is correct. 
        </div>

        <template v-if="getIsNewContract">
          <div class="mb-4">
            New contract start date will be created: <span class="font-weight-bold">{{new Date() | formatCustomDate('YYYY-MM-DD')}}</span>
          </div>
        </template>

        <template v-if="getAdhocCharges.length">
          <div class="font-weight-bold mb-4">
            An ad hoc invoice of {{getAdhocChargesTotal | formatCurrency}} + VAT will be sent to {{getCurrentAccount.email_address}}
          </div>
        </template>

        <div>
          <v-checkbox v-model="confirmation" label="I confirm I have checked all the changes" hide-details />
        </div>

        <div class="mt-3">
          <v-btn color="primary" outlined class="mb-0 mr-2" @click="set_stepPrev">Back</v-btn>
        </div>

      </v-form>
    </template>

  </BaseSection>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';
  import BaseSection from '@/components/Products/ProductTypes/AllProducts/ChangeTariff/Sections/BaseSection';
  
  export default {
    props: {
      step: {
        type: Number,
        default: 0
      },
    },

    components: { BaseSection },

    computed: {
      ...mapGetters('changeTariff',['getSection','getIsNewContract','getAdhocCharges','getAdhocChargesTotal']),
      ...mapGetters('accounts',['getCurrentAccount']),

      confirmation: {
        get() { return this.getSection('confirm'); },

        set(val){
          this.set_section({section:'confirm',value:val});
        }
      },
    },

    methods: {
      ...mapMutations('changeTariff',['set_section','set_stepNext','set_stepPrev']),

      submitContinue(){
        this.set_stepNext();
      },
    },
  }
</script>

<style lang="scss" scoped>

  ::v-deep {
    .v-input--checkbox {
      margin-top: 0;
      padding-top: 0;
    }
  }

</style>
